import { call } from 'redux-saga/effects';
import { bigWinHandler } from '../bigWins';
import { personalHandler } from '../personal';
import { getChannelNamespace } from '../../../../utils/centrifugo';
import { liveDataHandler } from '../liveData';
import { CHANNEL_NAMESPACES } from '../../../../constants/centrifugo';

/**
 * handlers-map for different channels
 */
const PUBLICATION_HANDLERS_MAP = {
  [CHANNEL_NAMESPACES.LIVE_DATA]: liveDataHandler,
  [CHANNEL_NAMESPACES.BIG_WINS]: bigWinHandler,
  [CHANNEL_NAMESPACES.PERSONAL]: personalHandler,
};

export function* publicationHandler({ channel, data }) {
  const namespace = getChannelNamespace(channel);

  if (PUBLICATION_HANDLERS_MAP[namespace]) {
    // can proceed
    yield call(PUBLICATION_HANDLERS_MAP[namespace], data);
  }
}
